import React, { Component } from 'react';
import { appService } from '../_services';

let parameters = '', useragent = navigator.userAgent;
export class PdfReader extends Component {
    constructor(props) {
        super(props);
        this.state = { //this is a temporary fix for hiding/showing links if not logged in -  condition will be modified 
            user: ''
        }
    }
    componentDidMount(props) {
        var self = this;
        var fileType = this.props.match.params.fileType;
        var header = document.getElementsByTagName('header');
        header[0].remove();
        var footer = document.getElementsByTagName('footer');
        footer[0].remove();
        var fileName = this.props.match.params.pdffile.split('.').slice(0, -1).join('.')
        this.state.user = JSON.parse(localStorage.getItem('user'));
        parameters = { pdffile: fileName, code: this.props.match.params.code, user: this.state.user, fileType: this.props.match.params.fileType };
        appService.getByIssueId('Product/GetSIQTagValues', parameters) //Pradip Lalvani
            .then(function (data) {
                if (data == "Error found") {
                    self.setState({ IsError: true });
                }
                else {
                    var Param;
                    if (localStorage.getItem('Param') !== null) {
                        Param = localStorage.getItem('Param');
                    }
                    if (fileType == "Journals" || fileType == "Journal") {
                        if (data.isFree) {
                            if (localStorage.getItem('user') !== null) {
                                window['NTPT_PGEXTRA'] = 'event_type=journal_abstract &ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &volume=' + data.volume + ' &issue=' + data.issueNo + ' &article_id=' + data.articleTypeId + ' &article_title= ' + data.articleTitle + '&authors=' + data.authorName + '&user_id=' + localStorage.getItem('salesForceID') + '&user=' + localStorage.getItem('user') + ' &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                                const script = document.createElement("script");
                                script.src = "/siqpagetag.js";
                                script.async = true;
                                document.body.appendChild(script);
                            }
                            else {
                                window['NTPT_PGEXTRA'] = 'event_type=journal_abstract &ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &volume=' + data.volume + ' &issue=' + data.issueNo + ' &article_id=' + data.articleTypeId + ' &article_title= ' + data.articleTitle + '&authors=' + data.authorName + '&Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                                const script = document.createElement("script");
                                script.src = "/siqpagetag.js";
                                script.async = true;
                                document.body.appendChild(script);
                            }
                        }
                        else if (localStorage.getItem('user') !== null) {
                            window['NTPT_PGEXTRA'] = 'event_type=full-text pdf&ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &volume=' + data.volume + ' &issue=' + data.issueNo + ' &article_id=' + data.articleTypeId + ' &article_title= ' + data.articleTitle + '&authors=' + data.authorName + '&user_id=' + localStorage.getItem('salesForceID') + '&user=' + localStorage.getItem('user') + ' &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                            const script = document.createElement("script");
                            script.src = "/siqpagetag.js";
                            script.async = true;
                            document.body.appendChild(script);
                        }
                        else {
                            window['NTPT_PGEXTRA'] = 'event_type=full-text pdf&ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &volume=' + data.volume + ' &issue=' + data.issueNo + ' &article_id=' + data.articleTypeId + ' &article_title= ' + data.articleTitle + '&authors=' + data.authorName + '&Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                            const script = document.createElement("script");
                            script.src = "/siqpagetag.js";
                            script.async = true;
                            document.body.appendChild(script);
                        }

                    }
                    else if ((fileType == "Manuals" || fileType == "Manual") || (fileType == "Encyclopedias" || fileType == "Encyclopedia")) {

                        if (data.isFree) {
                            if (localStorage.getItem('user') !== null) {
                                if (Param !== "TOC") {
                                    window['NTPT_PGEXTRA'] = 'event_type=journal_abstract &ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &authors=' + data.authorName + ' &article_id=' + data.articleTypeId + ' &article_title=' + data.articleTitle + ' &Country=' + data.country + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                                    const script = document.createElement("script");
                                    script.src = "/siqpagetag.js";
                                    script.async = true;
                                    document.body.appendChild(script);
                                }
                                else {
                                    window['NTPT_PGEXTRA'] = 'event_type=journal_abstract &ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &authors=' + data.authorName + ' &article_id=' + data.articleTypeId + ' &article_title=' + data.articleTitle + ' &Country=' + data.country + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                                    const script = document.createElement("script");
                                    script.src = "/siqpagetag.js";
                                    script.async = true;
                                    document.body.appendChild(script);
                                }

                            }
                            else {
                                if (Param !== "TOC") {
                                    window['NTPT_PGEXTRA'] = 'event_type=journal_abstract &ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &authors=' + data.authorName + ' &article_id=' + data.articleTypeId + ' &article_title=' + data.articleTitle + ' &Country=' + data.country + ' &User= &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                                    const script = document.createElement("script");
                                    script.src = "/siqpagetag.js";
                                    script.async = true;
                                    document.body.appendChild(script);
                                }
                                else {
                                    window['NTPT_PGEXTRA'] = 'event_type=journal_abstract &ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &authors=' + data.authorName + ' &article_id=' + data.articleTypeId + ' &article_title=' + data.articleTitle + ' &Country=' + data.country + ' &User= &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                                    const script = document.createElement("script");
                                    script.src = "/siqpagetag.js";
                                    script.async = true;
                                    document.body.appendChild(script);
                                }
                            }
                        }
                        else if (localStorage.getItem('user') !== null) {
                            if (Param !== "TOC") {
                                window['NTPT_PGEXTRA'] = 'event_type=full-text pdf&ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &authors=' + data.authorName + ' &article_id=' + data.articleTypeId + ' &article_title=' + data.articleTitle + ' &Country=' + data.country + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                                const script = document.createElement("script");
                                script.src = "/siqpagetag.js";
                                script.async = true;
                                document.body.appendChild(script);
                            }
                            else {
                                window['NTPT_PGEXTRA'] = 'event_type=full-text pdf&ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &authors=' + data.authorName + ' &article_id=' + data.articleTypeId + ' &article_title=' + data.articleTitle + ' &Country=' + data.country + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                                const script = document.createElement("script");
                                script.src = "/siqpagetag.js";
                                script.async = true;
                                document.body.appendChild(script);
                            }

                        }
                        else {
                            if (Param !== "TOC") {
                                window['NTPT_PGEXTRA'] = 'event_type=full-text pdf&ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &authors=' + data.authorName + ' &article_id=' + data.articleTypeId + ' &article_title=' + data.articleTitle + ' &Country=' + data.country + ' &User= &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                                const script = document.createElement("script");
                                script.src = "/siqpagetag.js";
                                script.async = true;
                                document.body.appendChild(script);
                            }
                            else {
                                window['NTPT_PGEXTRA'] = 'event_type=full-text pdf&ProductId=' + data.productId + ' &ProductTitle=' + data.productTitle + ' &authors=' + data.authorName + ' &article_id=' + data.articleTypeId + ' &article_title=' + data.articleTitle + ' &Country=' + data.country + ' &User= &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                                const script = document.createElement("script");
                                script.src = "/siqpagetag.js";
                                script.async = true;
                                document.body.appendChild(script);
                            }
                        }
                    }
                    var msg = {
                        ArticleTitle: window['NTPT_PGEXTRA']
                    }
                    var Logurl = 'Product/LogData';
                    appService.submit(Logurl, msg).then(function (data) {

                    });
                }
            });
    }
    render() {

        return (
            <div className="row">
                <div className="col mr-4">
                    <form>
                        <iframe src={'/api/Product/CitationPDFViewer?file=' + this.props.match.params.fileType + "\\" + this.props.match.params.code + "\\" + this.props.match.params.pdffile} id="ipayframe" width="100%" height="850px" frameBorder="0"></iframe>
                    </form>
                </div>

            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/PdfReader.jsx